import { Endpoint, api } from "../data/api";
import { Account } from "../domain";

export function getAccounts(characterId: number): Promise<Account[]> {
  return api.post(Endpoint.getAccounts, { characterId })
    .then(items => items.map(item => new Account(item)));
}